export default __webpack_public_path__ + "static/media/head02_ko_sp.798f2728.png";